import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PrivacyPolicyComponent } from './privacy-policy.component';
import { TranslateModule } from "@ngx-translate/core";
import { BreadcrumbsModule } from '@shared/components/breadcrumbs/breadcrumbs.module';

@NgModule({
  imports: [
    CommonModule,
    TranslateModule,
    BreadcrumbsModule
  ],
  declarations: [
    PrivacyPolicyComponent
  ]
})
export class PrivacyPolicyModule { }
